import COUNTRIES from "./constants/countries";
import RatingCountry from "./RatingCountry";

function RatingTab(props) {
    const { critic } = props;

    return (
        <div className="div-table-wrapper" aria-label={`${critic} wine vintage ratings by region and year`}>
            <div className="div-table" role="table">
                {COUNTRIES.map((country) => (
                    <RatingCountry key={country.key} country={country} critic={critic} />
                ))}
            </div>
        </div>
    )
}

export default RatingTab;
